const clientId = 1000000;

const BASE_PATH = '/api/offers/v1';
const RETAILMEDIA_PATH = '/api/retailmedia/v2';
export const CAROUSELS_API_PATH = `${BASE_PATH}/carousels`;
export const SECONDARY_BANNERS_API_PATH = `${RETAILMEDIA_PATH}/Ad/MakeDecision`;

export const GET_FAV_STORES_PATH = `/api/offers/v1/Merchants?isFavourites=true`;
export const UPDATE_FAV_STORES_PATH = `/api/offers/v1/Favourites`;

// RETAIL MEDIA
export const FEATURED_ARTICLE_API_PATH = `/api/articles?pagination[pageSize]=12&sort[0]=published_date:DESC&populate[1]=seo&populate[2]=seo.meta_image&populate[3]=seo.og&populate[4]=seo.og.og_image`;
